/* models/glyphs/area.js */ function _(require, module, exports) {
    const glyph_1 = require(80) /* ./glyph */;
    const utils_1 = require(84) /* ./utils */;
    class AreaView extends glyph_1.GlyphView {
        draw_legend_for_index(ctx, bbox, index) {
            utils_1.generic_area_legend(this.visuals, ctx, bbox, index);
        }
    }
    exports.AreaView = AreaView;
    AreaView.__name__ = "AreaView";
    class Area extends glyph_1.Glyph {
        constructor(attrs) {
            super(attrs);
        }
        static init_Area() {
            this.mixins(['fill', 'hatch']);
        }
    }
    exports.Area = Area;
    Area.__name__ = "Area";
    Area.init_Area();
}
